module.exports = __webpack_public_path__ + "img/index-sol1.cd3a37bf.png";